// @ts-nocheck

// Ratio min
export const ViewportRatioMin = 1.2;

// Reference width  for the landscape viewport in pixels
export const ViewportWidthRef = 320;

// Reference height for the landscape viewport in pixels
export const ViewportHeightRef = 480;
